import { apiUrls } from '../api/api-urls'
import { fetchMutation } from '../utils'

export const getCompanySuggestions = (platform: string, channel: string) =>
  fetchMutation<{ name: string; id: string }[]>(`${apiUrls.reports}/${platform}/${channel}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }, true)
